import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectContextLocale } from '@store/context/context.selector';
import { IHotelsAppState } from '@store/index';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'am-alert-content',
  styleUrls: ['./alert-content.component.scss'],
  templateUrl: './alert-content.component.html',
})
export class AlertContentComponent implements OnChanges, OnDestroy {
  public openAlert: boolean;
  public mobileStyle: boolean;
  public iconImage: string;
  public myTitle: string;
  private unSubscribe$ = new Subject<void>();

  @Input()
  public showAlert: any;
  @Input()
  set mobile(status: any) {
    this.mobileStyle = !!status;
  }
  @Input()
  set title(title_name: string) {
    this.myTitle = title_name;
  }

  @Input()
  set imageName(name: any) {
    this.setImage(name);
  }

  constructor(private store$: Store<IHotelsAppState>) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.showAlert) {
      this.showPaymentsMethodsAlert(changes.showAlert.currentValue.value);
    }
  }

  public setImage(imageName) {
    this.store$.pipe(select(selectContextLocale), takeUntil(this.unSubscribe$)).subscribe(() => {
      this.iconImage = `/hotels/results/dist/es-AR/assets/images/${imageName}`;
    });
  }

  public show() {
    this.openAlert = true;
  }

  public hide() {
    this.openAlert = false;
  }

  public showPaymentsMethodsAlert(status: boolean) {
    if (status) {
      this.show();
      setTimeout(() => {
        this.hide();
      }, 5000);
    }
  }

  public ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.unsubscribe();
  }
}
